const companyAuditStatus = [
  { id: 1, name: 'Has auditor' },
  { id: 2, name: 'Has reservation to not have an auditor' },
  { id: 3, name: 'Auditor resigned at own will' },
];

export default companyAuditStatus;
